import { render } from "./social_responsibility.vue?vue&type=template&id=56410e73&scoped=true"
import script from "./social_responsibility.vue?vue&type=script&lang=js"
export * from "./social_responsibility.vue?vue&type=script&lang=js"

import "./social_responsibility.vue?vue&type=style&index=0&id=56410e73&scoped=true&lang=less"

import exportComponent from "D:\\STD7159\\源码管理\\前端\\stgd.oa.ows.inernetweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56410e73"]])

export default __exports__